import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PATH } from '@app/constants';
import { User } from '@app/models';
import { UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
  selector: 'mnf-modal-promotions',
  templateUrl: './modal-promotions.component.html',
  styleUrls: ['./modal-promotions.component.scss'],
})
export class ModalPromotionsComponent implements OnInit {

  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private readonly ID_TOKEN = 'ID_TOKEN';
  private readonly EXP_AUTH = 'EXP_AUTH';
  private readonly UNE_FORM = 'UNE_FORM';
  private readonly PROM = 'PROM'

  /** Variable global para guardar la información del inversionista  */
  user: User;

  constructor(
    private userServ: UserService, 
    private modalServ: ModalService, 
    private dialogRef: MatDialogRef<ModalPromotionsComponent>,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userServ.getUserInf().subscribe(res => {
      this.user = res;
    })
  }

  cancelSubscription() {
    this.userServ.cancelsubscription(false).subscribe(r => {
      const m = this.modalServ.modalCustom({
        img: 'https://static.monific.com/assets/assets-app/img/icon/img/attention.svg',
        title: 'Suscripción cancelada',
        message: `Se ha removido la suscripción con éxito, si desea que le llegue nuevamente los mensaje de <a href="https://centrodeayuda.monific.com/c%C3%B3mo-cancelar-tu-suscripci%C3%B3n-a-correos-promocionales-de-monific" (click)="cancel()">clic aquí</a>`,
        buttonText: 'Aceptar',
      })

      m.afterClosed().subscribe((r) => {
        if (r) {
          this.cancel();
        }
      })

    }) 
  }

  /** Función para eliminar el parametro `prom` y redireccionar al login */
  cancel() {
    this.remoevAllSession();
    this.dialogRef.close();
    this.router.navigate([PATH.LOGIN]);
  }

  remoevAllSession() {
    sessionStorage.removeItem(this.JWT_TOKEN);
    sessionStorage.removeItem(this.REFRESH_TOKEN);
    sessionStorage.removeItem(this.ID_TOKEN);
    sessionStorage.removeItem(this.EXP_AUTH);
    sessionStorage.removeItem(this.UNE_FORM);
    sessionStorage.removeItem(this.PROM);
  }
}
